import type { UseFormReturnType } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { ErrorDeApi } from './api.ts';

const fechaHora = new Intl.DateTimeFormat('es-AR', {
  dateStyle: 'short', timeStyle: 'short', timeZone: 'America/Argentina/Buenos_Aires',
});

export const formatearFechaHora = (iso: string | null | undefined): string => (iso ? fechaHora.format(new Date(iso)) : '—');

/** 'AAAA-MM-DD' → 'DD/MM/AAAA' sin pasar por Date (no se corre de día). */
export const formatearFecha = (f: string | null | undefined): string => (f ? f.split('-').reverse().join('/') : '—');

/**
 * Muestra el error de la API: los de validación van a cada campo del
 * formulario; el resto, en un aviso.
 */
export function mostrarError<T>(e: unknown, form?: UseFormReturnType<T>): void {
  if (form && e instanceof ErrorDeApi && e.detalles.length) {
    form.setErrors(Object.fromEntries(e.detalles.map((d) => [d.campo || 'general', d.mensaje])));
  }
  notifications.show({ color: 'red', title: 'No se pudo guardar', message: e instanceof Error ? e.message : 'Error inesperado' });
}

export const avisarOk = (mensaje: string) => notifications.show({ color: 'teal', message: mensaje });

/** Rango AAAA-MM-DD como meses: '03/2026', o '01/2026 – 03/2026'. Sin rango, '—'. */
export function formatearPeriodo(desde: string | null, hasta: string | null): string {
  if (!desde || !hasta) return '—';
  const mes = (f: string) => `${f.slice(5, 7)}/${f.slice(0, 4)}`;
  return desde.slice(0, 7) === hasta.slice(0, 7) ? mes(desde) : `${mes(desde)} – ${mes(hasta)}`;
}

/** Período de un archivo: '2026-T3' → '3.er trim. 2026'; '2026-09' → '09/2026'. */
export function formatearPeriodoArchivo(p: string | null): string {
  if (!p) return '';
  const t = p.match(/^(\d{4})-T(\d)$/);
  if (t) return `${t[2]}.er trim. ${t[1]}`;
  return `${p.slice(5, 7)}/${p.slice(0, 4)}`;
}
